import React from "react";
import { appHost } from "../../helpers/uri";
import is_null from "../../helpers/is_null";

const AcceptanceLetter = ({ v }) => {
  const _show = () => {
    window.open(`${appHost}/acceptance_letter/${v?._id}`, `Print Acceptance Letter`, `_parent`, `width=450,height=650`);
  };
  return (
    <button disabled={is_null(v.acceptanceFee) ? true : false} onClick={_show} className="btn btn-info text-white float-right mr-3 ml-3">
      Print Acceptance Letter <i className="fa-solid fa-file-text"></i>
    </button>
  );
};

export default AcceptanceLetter;
